// init AOS
document.addEventListener('DOMContentLoaded', function () {
	AOS.init({
		duration: 1000,
		once: true,
		offset: 50
	});
}, false);

// init Micromodal
MicroModal.init({
  openClass: 'is-open',
  disableScroll: true,
  disableFocus: true,
  awaitOpenAnimation: true,
  awaitCloseAnimation: true
});
  
// Drag to scroll
const dragScroll = document.querySelectorAll('.drag-scroll');

/* dragScroll.forEach(ele => {
  let pos = { top: 0, left: 0, x: 0, y: 0 };

  const mouseDownHandler = function (e) {
		ele.style.cursor = 'grabbing';
		ele.style.userSelect = 'none';

		pos = {
			left: ele.scrollLeft,
			top: ele.scrollTop,
			// Get the current mouse position
			x: e.clientX,
			y: e.clientY,
		};

		document.addEventListener('mousemove', mouseMoveHandler);
		document.addEventListener('mouseup', mouseUpHandler);
  };

  const mouseMoveHandler = function (e) {
		// How far the mouse has been moved
		const dx = e.clientX - pos.x;
		const dy = e.clientY - pos.y;

		// Scroll the element
		ele.scrollTop = pos.top - dy;
		ele.scrollLeft = pos.left - dx;
  };

  const mouseUpHandler = function () {
		ele.style.cursor = 'grab';
		ele.style.removeProperty('user-select');

		document.removeEventListener('mousemove', mouseMoveHandler);
		document.removeEventListener('mouseup', mouseUpHandler);
  };

  // Attach the handler

  ele.addEventListener('mousedown', mouseDownHandler);
}); */

function slideUp(target, duration = 500) {
	target.style.transitionProperty = 'height, margin, padding';
	target.style.transitionDuration = duration + 'ms';
	target.style.boxSizing = 'border-box';
	target.style.height = target.offsetHeight + 'px';
	target.offsetHeight;
	target.style.overflow = 'hidden';
	target.style.height = 0;
	target.style.paddingTop = 0;
	target.style.paddingBottom = 0;
	target.style.marginTop = 0;
	target.style.marginBottom = 0;
	window.setTimeout( () => {
			target.style.display = 'none';
			target.style.removeProperty('height');
			target.style.removeProperty('padding-top');
			target.style.removeProperty('padding-bottom');
			target.style.removeProperty('margin-top');
			target.style.removeProperty('margin-bottom');
			target.style.removeProperty('overflow');
			target.style.removeProperty('transition-duration');
			target.style.removeProperty('transition-property');
			//alert("!");
	}, duration);
}

function slideDown(target, duration = 500) {
	target.style.removeProperty('display');
	let display = window.getComputedStyle(target).display;
	if (display === 'none') display = 'block';
	target.style.display = display;
	let height = target.offsetHeight;
	target.style.overflow = 'hidden';
	target.style.height = 0;
	target.style.paddingTop = 0;
	target.style.paddingBottom = 0;
	target.style.marginTop = 0;
	target.style.marginBottom = 0;
	target.offsetHeight;
	target.style.boxSizing = 'border-box';
	target.style.transitionProperty = "height, margin, padding";
	target.style.transitionDuration = duration + 'ms';
	target.style.height = height + 'px';
	target.style.removeProperty('padding-top');
	target.style.removeProperty('padding-bottom');
	target.style.removeProperty('margin-top');
	target.style.removeProperty('margin-bottom');
	window.setTimeout( () => {
		target.style.removeProperty('height');
		target.style.removeProperty('overflow');
		target.style.removeProperty('transition-duration');
		target.style.removeProperty('transition-property');
	}, duration);
}
  
function slideToggle(target, duration = 500) {
	if (window.getComputedStyle(target).display === 'none') {
		return slideDown(target, duration);
	} else {
		return slideUp(target, duration);
	}
}

function fadeIn(target, duration = 500) {
	target.style.display = '';
	target.style.opacity = 0;
	var last = +new Date();
	var tick = function() {
		target.style.opacity = +target.style.opacity + (new Date() - last) / duration;
		last = +new Date();
		if (+target.style.opacity < 1) {
			(window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
		}
	};
	tick();
}

$('.site-header .site-header__wrapper .site-header__wrapper__right predictive-search .search__Close').on('click', function(){
  $('li.Desktop_Search').hide();
  $('body.search-box .top-links--icon-links li a.search-button-desktop').show();
})

$(".search-button-desktop").click(function() { 
    console.log('Clicked');
  $('.Desktop_Search').show();  
  //$('.search-button-desktop .header--supporting-text').hide();
  $('body').addClass('search-box');
  $('.search-button-desktop').hide();
});

$('.site-header .site-header__wrapper .site-header__wrapper__right predictive-search .search__Close').on('click', function(){
  $('li.Desktop_Search').hide();
  $('body.search-box .top-links--icon-links li a.search-button-desktop').show();
})

$(document).click(function() {
  var container = $(".search-button-desktop, .Desktop_Search");
  if (!container.is(event.target) && !container.has(event.target).length) {
    $('.Desktop_Search').hide();  
    $('.search-button-desktop .header--supporting-text').show();
    $('.search-button-desktop').css('display','flex');
  }
});

$( document ).ready(function() {
  $('.Alphabets_Single').click(function() {
    // console.log('Clicked');
    var alpha_value = $(this).children('input').val();
    $('.Selected_Alphabet').text(alpha_value);
  });  
});

document.body.addEventListener('click', event => {
  event.stopPropagation();
  if (event.target.classList.contains('')) {
    event.preventDefault();

    const parent = event.target.parentElement;
    // const content = parent.querySelector('.horizontal--tab-content');

    // parent.classList.toggle('active');
    // slideToggle(content, 400);
  }

  if (event.target.classList.contains('size-modal-trigger')) {
    event.preventDefault();
    const modal = event.target.dataset.modalTrigger;

    MicroModal.show(modal);
  }
});

// var srch = $('.Desktop_Search predictive-search').clone();
// $('.right-drawer-vue .drawer__header').after(srch)



window.pop = function(){
if(document.getElementById("Custom_Popup")){
  let popup = document.getElementById("Custom_Popup");
  let newElement = document.createElement('div');
  newElement.classList.add("Popup_Overlay");
  
  document.querySelector("#clickBtn").addEventListener('click',function(evt){
    popup.style.display = 'block';
    popup.classList.add('Show');
    document.body.style.overflow = 'hidden';
    document.body.prepend(newElement);  
  });
  
  document.querySelector("#closeBtn").addEventListener('click',function(evt){
    popup.style.display = 'none';
    newElement.remove();
    document.body.style.overflow = 'auto'; 
  });
  
  document.getElementById('Inquire_Form').querySelector('[type="submit"]').addEventListener('click', function(event) {
    event.preventDefault();
    var ContactFormTitle = document.getElementById('Contact_Form_Title').value;
    var ContactFormName = document.getElementById('Contact_Form_First_Name').value;
    var ContactFormLastName = document.getElementById('Contact_Form_Last_Name').value;
    var ContactFormEmail = document.getElementById('Contact_Form_Email').value;
    var ContactFormTelephone = document.getElementById('Contact_Form_Telephone').value;

    if(ContactFormTitle.trim() === '' && ContactFormName.trim() === '' && ContactFormLastName.trim() === '' && ContactFormEmail.trim() === '' && ContactFormTelephone.trim() === ''){
      document.getElementById('Contact_Form_Title').parentElement.classList.add('Error');
      document.getElementById('Contact_Form_Title').parentElement.querySelector('.Field_Error').removeAttribute('hidden');
      document.getElementById('Contact_Form_First_Name').parentElement.classList.add('Error');
      document.getElementById('Contact_Form_First_Name').parentElement.querySelector('.Field_Error').removeAttribute('hidden');
      document.getElementById('Contact_Form_Last_Name').parentElement.classList.add('Error');
      document.getElementById('Contact_Form_Last_Name').parentElement.querySelector('.Field_Error').removeAttribute('hidden');
      document.getElementById('Contact_Form_Email').parentElement.classList.add('Error');
      document.getElementById('Contact_Form_Email').parentElement.querySelector('.Field_Error').removeAttribute('hidden');
      document.getElementById('Contact_Form_Telephone').parentElement.classList.add('Error');
      document.getElementById('Contact_Form_Telephone').parentElement.querySelector('.Field_Error').removeAttribute('hidden');
      return;
    }
    
     if (ContactFormTitle.trim() === '') {
      document.getElementById('Contact_Form_Title').parentElement.classList.add('Error');
       document.getElementById('Contact_Form_Title').parentElement.querySelector('.Field_Error').removeAttribute('hidden');
      return;
    }else{
      document.getElementById('Contact_Form_Title').parentElement.classList.remove('Error');
       document.getElementById('Contact_Form_Title').parentElement.querySelector('.Field_Error').setAttribute('hidden','hidden');
    }
    
    if (ContactFormName.trim() === '') {
      document.getElementById('Contact_Form_First_Name').parentElement.classList.add('Error');
      document.getElementById('Contact_Form_First_Name').parentElement.querySelector('.Field_Error').removeAttribute('hidden');
      return;
    }else{
      document.getElementById('Contact_Form_First_Name').parentElement.classList.remove('Error');
      document.getElementById('Contact_Form_First_Name').parentElement.querySelector('.Field_Error').setAttribute('hidden','hidden');
    }
  
    if (ContactFormLastName.trim() === '') {
      document.getElementById('Contact_Form_Last_Name').parentElement.classList.add('Error');
      document.getElementById('Contact_Form_Last_Name').parentElement.querySelector('.Field_Error').removeAttribute('hidden');
      return;
    }else{
      document.getElementById('Contact_Form_Last_Name').parentElement.classList.remove('Error');
      document.getElementById('Contact_Form_Last_Name').parentElement.querySelector('.Field_Error').setAttribute('hidden','hidden');
    }

    if (ContactFormEmail.trim() === '') {
      document.getElementById('Contact_Form_Email').parentElement.classList.add('Error');
      document.getElementById('Contact_Form_Email').parentElement.querySelector('.Field_Error').removeAttribute('hidden');
      return;
    }else{
      document.getElementById('Contact_Form_Email').parentElement.classList.remove('Error');
      document.getElementById('Contact_Form_Email').parentElement.querySelector('.Field_Error').setAttribute('hidden','hidden');
    }
  
    var emailRegex = /^\S+@\S+\.\S+$/;
    if (!emailRegex.test(ContactFormEmail)) {
      document.getElementById('Contact_Form_Email').parentElement.classList.add('Error');
      document.getElementById('Contact_Form_Email').parentElement.querySelector('.Field_Error').removeAttribute('hidden');
      return;
    }else{
      document.getElementById('Contact_Form_Email').parentElement.classList.remove('Error');
      document.getElementById('Contact_Form_Email').parentElement.querySelector('.Field_Error').setAttribute('hidden','hidden');
    }
    
    if (ContactFormTelephone.trim() === '') {
      document.getElementById('Contact_Form_Telephone').parentElement.classList.add('Error');
      document.getElementById('Contact_Form_Telephone').parentElement.querySelector('.Field_Error').removeAttribute('hidden');
      return;
    }else{
      document.getElementById('Contact_Form_Telephone').parentElement.classList.remove('Error');
      document.getElementById('Contact_Form_Telephone').parentElement.querySelector('.Field_Error').setAttribute('hidden','hidden');
    }
  
    // Validate phone number format using regular expression
    // var phoneRegex = /^\d{10}$/;
    // if (!phoneRegex.test(ContactFormTelephone)) {
    //   alert('Please enter a valid phone number.');
    //   return;
    // }
    document.getElementById('Inquire_Form').submit();
  });
  
 }
}

// var input = document.querySelector("#Phone");
// window.intlTelInput(input, {
//   separateDialCode: true
// });

$(document).ready(function(){
  let productForm = document.querySelector('.product-details-wrapper .form-vertical'),
      char = document.querySelector('.swatch.character');

  if (char) {
    let inputWrap = char.querySelector('.swatch-items-wrapper'),
        customName = document.querySelector('#customName'),
        charLeftWrap = document.querySelector('.chars-left span'),
        charLimit = inputWrap.querySelector('input:checked').value;

    charLeftWrap.innerHTML = charLimit;
    customName.maxLength = charLimit;

    inputWrap.addEventListener('change', function(e){
      charLimit = e.target.value;
      customName.maxLength = charLimit
      curNameLength = customName.value.length
      charLeft = charLimit - curNameLength
      charLeftWrap.innerHTML = charLeft;
      charLeftWrap.style.color = 'initial';

      if (charLeft < 0) {
        customName.value = '';
        charLeftWrap.innerHTML = charLimit;
      } 
    })

    customName.addEventListener('input', function(){
      charLeft = charLimit - this.value.length;
      charLeftWrap.innerHTML = charLeft;

      if (charLeft <= 0) {
        charLeftWrap.style.color = 'red'
      } else {
        charLeftWrap.style.color = 'initial';
      }
    })
  }
});

function setupTabs (){
  document.querySelectorAll('.horizontal--tabs-btn').forEach(button=>{
    button.addEventListener('click',(e)=>{
      e.preventDefault();
      const sidebar = button.parentElement;
      const tabs = sidebar.parentElement;
      const tabNumber = button.dataset.forTab;
      const tabActivate = tabs.querySelector(`.horizontal--tab-content-container[data-tab="${tabNumber}"]`)
      sidebar.querySelectorAll('.horizontal--tabs-btn').forEach(button=>{
        button.classList.remove('active')
      })
       tabs.querySelectorAll('.horizontal--tab-content-container').forEach(tab=>{
        tab.classList.remove('active')
        tab.style.display = 'none'
      })
      button.classList.add('active')
      tabActivate.classList.add('active')
      tabActivate.style.display = 'block'
    })
  })
}

$(document).ready(function(){
  setupTabs();
})

$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

$(window).on('resize scroll', function() {
      $('.drag-scroll-indicator').each(function() {
    
    if ($(this).isInViewport()) {
      setTimeout(() => {
        $(this).addClass('on-view')
      }, 4000);
    } else {
        $(this).removeClass('on-view')
    }
  });
});


function ringsizeSlideout() {
  const inputToggle = document.querySelector('#ring-size--swatch .header');
  const ringSizeDrawer = document.querySelector('#ring-size--slideout');
  const ringSizes = document.querySelectorAll('#ring-size--popup input');
  const sizeInput = document.querySelector('#ring-size--swatch .swatch-items-wrapper');
  const ringSizeBg = document.querySelector('#ring-size--slideout-bg');
  let isDrawerOpen = false;

  ringSizes.forEach(el => {
    el.addEventListener("click", (event) => {
      const clickedOption = event.target.closest('input');
      const optionValue = clickedOption.value.replace(" ", "");
      const optiontoClass = optionValue.replace(".", "-")
      const selectedInput = sizeInput.querySelector('.ring--size-' + optiontoClass);
      console.log(selectedInput)
      selectedInput.click();
      setTimeout(() => {
        toggleRingSizeDrawer();
      }, 300);
    })
  });

  if (inputToggle) {
    inputToggle.addEventListener('click', (event) => {
      toggleRingSizeDrawer();
    });
  }


  function toggleRingSizeDrawer() {
    if (ringSizeDrawer.classList.contains('open')) {
      ringSizeDrawer.classList.remove('open');
      ringSizeBg.classList.remove('open')
      isDrawerOpen = false;
    } else {
      ringSizeScroll();
      ringSizeDrawer.classList.add('open')
      ringSizeBg.classList.add('open')
      isDrawerOpen = true;
    }
  }

  document.addEventListener('keydown', event => {
    if (isDrawerOpen && event.key === 'Escape') {
      toggleRingSizeDrawer();
    }
  })

  if (ringSizeBg) {
    ringSizeBg.addEventListener('click', evt => {
      if (isDrawerOpen) {
        toggleRingSizeDrawer();
      }
    })
  }
}

function ringSizeScroll() {
  const body = document.body;
  const rs = document.querySelector('#ring-size--popup');
  const ringSizeContent = document.querySelector('.ring-size--content');
  rs.style.overflowY = 'hidden';
  body.classList.remove('js-drawer-open');
  let cH = ringSizeContent.offsetHeight;
  let wH = window.innerHeight;
  if (wH <= cH) {
    body.classList.add('js-drawer-open')
    rs.style.overflowY = 'scroll'
  }
  window.addEventListener('resize', (event) => {
    if (wH <= cH) {
      body.classList.add('js-drawer-open')
      rs.style.overflowY = 'scroll'
    }
  })
}

$(document).ready(function(){
  ringsizeSlideout();
});
